import { SxProps, Typography } from "@mui/material";
import styles from "./SectionTitle.module.css";

interface SectionTitleProps {
  dataTestId: string;
  value: string;
  config?: SxProps;
}

export default function SectionTitle({
  dataTestId,
  value,
  config,
}: SectionTitleProps) {

  return (
    <Typography
      data-testid={dataTestId}
      variant="h2"
      className={styles.text}
      sx={config}
    >
      {value}
    </Typography>
  );
}
